var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.$style['newsletter-signup']},[_c('AppTransition',{attrs:{"name":"translate-y-sm","appear":""}},[_c(_vm.currentStep.component,{tag:"component",attrs:{"subscription-id":_vm.subscriptionId},on:{"submit":_vm.currentStep.onSubmit,"failure":_vm.onFailure}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }